import React from 'react';
import { PreConstructionProjectCarousel } from 'components/pages/newhomes/components/homes-carousel';
import styles from './style.module.scss';

import type { PreConstructionProject } from '@zoocasa/pre-construction';

interface Props {
  listings: PreConstructionProject[];
}

export default function NewHomesVIP({ listings }: Props) {
  return (
    <div className={styles.component}>
      <h2>Get Exclusive VIP Access</h2>
      <PreConstructionProjectCarousel project={listings} />
    </div>
  );
}
